import { useEffect, useState } from "react";

const usePokemonData = (pokeURL, id) => {
  const [individualDataPokemon, setIndividualDataPokemon] = useState(null);

  useEffect(() => {
    const pokemonUrlData = async () => {
      if (!pokeURL) return;
      const finalUrl = id ? `${pokeURL}/${id}` : pokeURL;

      try {
        const resPokeUrl = await fetch(finalUrl);
        if (!resPokeUrl.ok) throw new Error("We have problems with the url");
        const dataPokeUrl = await resPokeUrl.json();
        setIndividualDataPokemon(dataPokeUrl);
      } catch (error) {
        console.error("Error fetching data", error);
        setIndividualDataPokemon(null);
      }
    };
    if (pokeURL) {
      pokemonUrlData();
    }
  }, [pokeURL, id]);
  return individualDataPokemon;
};

export default usePokemonData;
